// extracted by mini-css-extract-plugin
export var black = "homeSection-module--black--f2b2c";
export var content = "homeSection-module--content--81eb7";
export var halfContainer = "homeSection-module--halfContainer--c0733";
export var image = "homeSection-module--image--8bce5";
export var logo = "homeSection-module--logo--ae292";
export var logoText = "homeSection-module--logoText--23ab5";
export var overlay = "homeSection-module--overlay--2b0bd";
export var select = "homeSection-module--select--25dff";
export var text = "homeSection-module--text--a26b0";
export var title = "homeSection-module--title--89865";
export var wrapper = "homeSection-module--wrapper--91940";